import SEO from "../../../../src/components/seo";
import { Container } from "../../../../src/blocks";
import * as React from 'react';
export default {
  SEO,
  Container,
  React
};